import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'

export const ProductCardGridWithPadding = styled(Grid)`
  padding-left: ${props => props.theme.typography.pxToRem(31 - 18)};
  padding-right: ${props => props.theme.typography.pxToRem(31 - 18)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-left: ${props => props.theme.typography.pxToRem(25)};
    padding-right: ${props => props.theme.typography.pxToRem(25)};
  }

    &&& {
        margin: 0;
    }
`